import React from "react";
import { connect } from "react-redux";
import { Col, Badge } from "react-bootstrap";
import PropTypes from "prop-types";

import Table from "../../../layout/table";
import ConditionalDropdown from "../../../layout/conditional-dropdown";
import ConditionalButton from "../../../layout/conditional-button";
import { v4 as uuidv4 } from "uuid";
import { send as pageInfo, loading } from "../../../actions/page";
import { list as getSurveys, global, register } from "../../../actions/surveys";
import { withNavigation } from "../../../utils/wrapper";
import { generate as generateKey } from "../../../utils/string";
import ImportModal from "./import";

class Settings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            size: 10,
            search: "",
            order: "name",
            index: 0,
            direction: "DESC",
            data: [],
            pages: 0,
            archived: 0,
            converted: 0,
            default: "",
            modal: {
                import: {
                    show: false,
                    data: []
                }
            },
            globals: []
        };
        this.props.loading(true);
        this.props.pageInfo({ title: "Surveys", breadcrumb: `Surveys` });
    }

    get headers() {
        return [
            {
                header: "Name",
                sortable: false,
                source: "name",
                className: "text-muted text-small text-uppercase w-25",
                onRender: this.onNameLinkFormat
            },
            {
                header: "Description",
                sortable: false,
                source: "description",
                className: "text-muted text-small text-uppercase w-50",
                onFormat: this.onLinkFormat
            },
            {
                header: "Tags",
                sortable: false,
                source: "flags",
                className: "text-muted text-small text-uppercase w-60",
                onRender: this.onFlagsFormat
            },
            {
                header: "",
                sortable: false,
                source: "uuid",
                className: "text-muted text-small text-uppercase text-end w-5",
                onRender: this.onActionsFormat
            }
        ]
    }

    onLinkFormat = (e, row) => {
        return `<a href="/dashboard/settings/surveys/editor/${row['uuid']}">${e}</a>`
    }

    onFlagsFormat = (e, row) => {
        const flags = Number(e) | 0;
        const defs = [
            [1, "people", "dark"],
            [2, "leads", "dark"],
            [4, "clients", "dark"],
            [8, "attorneys", "dark"],
            [16, "judges", "dark"],
            [32, "staff", "dark"],
            [65536, "profile", "secondary"],
            [131072, "lead", "secondary"],
            [262144, "client", "secondary"],
            [524288, "attorney", "secondary"],
            [1048576, "judge", "secondary"],
            [2097152, "staff", "secondary"],
            [4194304, "divorce", "secondary"],
            [8388608, "custody", "secondary"],
            [16777216, "support", "secondary"],
            [33554432, "civil", "secondary"],
            [67108864, "name change", "secondary"],
        ];
        if (row["hidden"]) defs.push([0, "hidden", "danger"]);
        return (
            <>
                {row["hidden"] && <Badge pill bg="danger" className="me-1">hidden</Badge>}
                {defs
                    .filter(([mask]) => (flags & mask) !== 0)
                    .map(([, label, bg], i) => (
                        <Badge key={i} pill bg={bg} className="me-1">
                            {label}
                        </Badge>
                    ))}
            </>)
    }

    onNameLinkFormat = (e, row) => {
        return (<>
            <a href={`/dashboard/settings/surveys/editor/${row['uuid']}`}>
                {e} ({row["key"]}) (v. { row["version"]}) {row["name"] === this.state.system ? <Badge pill bg="dark">Default</Badge> : ""}
            </a>
        </>);
    }

    onEditClick = (row) => {
        this.props.navigate(`/dashboard/settings/surveys/editor/${row.uuid}`);
    }

    onActionsFormat = (e, row) => (
        <ConditionalDropdown
            display
            enabled
            enabledVariant="link"
            icon="more-horizontal"
            buttonClassName="btn-icon btn-icon-only p-0 text-muted survey-list-action-toggle"
            menuClassName="survey-list-action-menu"
            minWidth="11rem"
            items={[
                {
                    icon: "edit",
                    caption: "Edit",
                    description: "Open survey editor",
                    onClick: () => this.onEditClick(row)
                }
            ]}
        >
            {""}
        </ConditionalDropdown>
    )

    loadData = async () => {
        this.props.loading(true);
        const items = await this.props.getSurveys({});
        const globals = await this.props.global();
        this.setState({
            items: [...items],
            globals: [...globals]
        });
        this.props.loading(false);
    }
    
    componentDidMount = () => {
        setTimeout(async () => {
            await this.loadData();
        }, 30);
    }

    onSaveClick = (e) => {

    }

    onTestClick = (e) => {

    }

    onChange = (e) => {

    }

    onNewClick = (e) => {
        this.props.navigate("/dashboard/settings/surveys/editor");
    }

    onImportClick = async (e) => {
        this.setState({
            modal: {
                import: {
                    show: true
                }
            }
        })
    }

    onImportOk = async (e, item) => {
        const unsafes = [];

        // collect keys already used for this sourceUuid
        for (let i = 0; i < this.state.items.length; i++) {
            const row = this.state.items[i]; // renamed from element to avoid confusion
            unsafes.push(row.key);
        }
        const safeKey = generateKey(item.key, unsafes, 8);
        const uuid = uuidv4();

        await this.props.register({ uuid, parentUuid: item.uuid, domain: item.key, key: safeKey, owner: uuid, version: item.version, published: true, name: item.name, description: item.description, meta: item.meta })
        await this.loadData();
        this.onImportCancel(e);
    }

    onImportCancel = async (e) => {
        this.setState({
            modal: {
                import: {
                    show: false
                }
            }
        })
    }

    render() {
        return (
            <>
                <Col md="8" className="float-right text-end">
                    <ConditionalButton enabledVariant="outline-primary" display enabled onEnabledClick={this.onNewClick} icon="plus" className="btn-icon btn-icon-start ms-0 ms-sm-1 w-100 w-md-auto me-2">New</ConditionalButton>
                    <ConditionalButton enabledVariant="outline-primary" display enabled onEnabledClick={this.onImportClick} icon="download">import</ConditionalButton>
                </Col>
                <Col xs="12">
                    <Table
                        headers={this.headers}
                        page={this.state.items}
                        size={this.state.size}
                        index={0}
                        pages={1}
                        searchable={false}
                        sizable={false}
                        sortable={false}
                    />
                </Col>
                <ImportModal show={this.state.modal.import.show} data={ this.state.globals  } onOk={this.onImportOk} onCancel={this.onImportCancel}></ImportModal>
            </>
    )}
}

Settings.propTypes = {
    auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    return ({
        auth: state.auth
    });
};

export default withNavigation(connect(mapStateToProps, { pageInfo, loading, getSurveys, global, register })(Settings));
